import { Component } from '@theme/component';

/**
 * Event button — emits a merchant-configured CustomEvent on click.
 *
 * The click is bound declaratively with `on:click="/emit"`, so there is no
 * listener to register or tear down and buttons added later still work.
 *
 * `detail` is parsed as JSON when it parses, otherwise the raw string is passed
 * through, so a merchant can supply either.
 */
class EventButton extends Component {
  emit() {
    const name = this.dataset.eventButton;
    if (!name) return;

    const raw = this.dataset.eventButtonDetail;
    let detail = null;
    if (raw) {
      try {
        detail = JSON.parse(raw);
      } catch {
        detail = raw;
      }
    }

    this.dispatchEvent(new CustomEvent(name, { bubbles: true, detail }));
  }
}

if (!customElements.get('event-button')) {
  customElements.define('event-button', EventButton);
}
